import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex flex-wrap ga-1"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppealAttachedFiles',
    props: {
        documents: { default: () => [] }
    },
    emits: ["remove"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_chip = _resolveComponent("v-chip");
            return (__props.documents.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.documents, (doc, index) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                            key: doc.link,
                            size: "small",
                            label: "",
                            variant: "tonal",
                            color: "primary",
                            closable: "",
                            "onClick:close": ($event) => (emit('remove', index))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                    start: "",
                                    size: "small"
                                }, {
                                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createTextVNode("mdi-paperclip", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(doc.fileName || "Document"), 1)
                            ]),
                            _: 2
                        }, 1032, ["onClick:close"]));
                    }), 128))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
